export default "__VITE_ASSET__BDK31hYn__"